import { Box, Step, StepLabel, Stepper } from '@mui/material';
import type { KeyboardEvent } from 'react';
import { guaranteesStepNavigationStyles } from './styles.ts';
import type {
  TGuaranteesStepNavigationItem,
  TGuaranteesStepNavigationViewProps,
} from './types.ts';
import {
  canActivateGuaranteesStep,
  getGuaranteesStepIconStyles,
  getGuaranteesStepLabelStyles,
} from './utils.ts';

const GuaranteesStepNavigationView = ({
  current,
  items,
  containerId,
  containerStyles,
  stepperStyles,
}: TGuaranteesStepNavigationViewProps) => {
  const handleStepKeyDown = (
    event: KeyboardEvent<HTMLDivElement>,
    item: TGuaranteesStepNavigationItem
  ) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    if (!canActivateGuaranteesStep(item)) {
      return;
    }

    event.preventDefault();
    item.onClick?.();
  };

  return (
    <Box id={containerId} sx={containerStyles}>
      <Stepper
        activeStep={current}
        alternativeLabel
        nonLinear
        orientation="horizontal"
        sx={stepperStyles}
      >
        {items.map((item) => {
          const isClickable = canActivateGuaranteesStep(item);
          const stepLabelStyles = getGuaranteesStepLabelStyles(isClickable);
          const stepIconStyles = getGuaranteesStepIconStyles(item.isPending);

          return (
            <Step
              key={item.key}
              active={item.status === 'process'}
              completed={item.status === 'finish'}
              disabled={item.disabled}
              sx={guaranteesStepNavigationStyles.step}
            >
              <StepLabel
                error={item.status === 'error'}
                role={isClickable ? 'button' : undefined}
                tabIndex={isClickable ? 0 : undefined}
                aria-label={item.ariaLabel}
                data-pending-navigation={item.isPending ? 'true' : undefined}
                onClick={isClickable ? item.onClick : undefined}
                onKeyDown={(event) => handleStepKeyDown(event, item)}
                sx={stepLabelStyles}
                slotProps={{
                  stepIcon: {
                    sx: stepIconStyles,
                  },
                }}
              >
                {item.title}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default GuaranteesStepNavigationView;
